import { withStyles } from '@material-ui/core';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';

// Custom accordion summary style
const AccordionSummary = withStyles(() => ({
    root: {
        borderTop: "1px solid #000",
        borderBottom: "1px solid #000",
        minHeight: 44,
        '&$expanded': {
            minHeight: 44,
        },
        padding: "0"
    },
    content: {
        margin: '6px 0px',
        '&$expanded': {
            margin: '6px 0px',
        },
    },
    expanded: {},
}))(MuiAccordionSummary);

export default AccordionSummary;